<div class="loader pt3 pb4 flex justify-start content-center items-center flex-col flex-1">
  <mat-spinner diameter="32"></mat-spinner>
  <span class="gray mat-subtitle-2" translate="">
    Retrieving your data
  </span>
</div>